module.exports = function() {
  return new Worker(__webpack_public_path__ + "fb30804d5129c5a16242.worker.js");
};